import React, { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";

const CategoryAlertDialog = ({
  show,
  handleClose,
  title,
  subtitle,
  buttonText,
  hint,
  onCancel,
  onClick,
  isDanger,
  value: initialValue = "",
  customService: initialCustomService = false,
  bannerService: initialBannerService = false,
}) => {
  const [reason, setReason] = useState(initialValue);
  const [customService, setCustomService] = useState(initialCustomService);
  const [bannerService, setBannerService] = useState(initialBannerService);

  useEffect(() => {
    setReason(initialValue);
    setCustomService(initialCustomService);
    setBannerService(initialBannerService);
  }, [initialValue, initialCustomService, initialBannerService]);

  const handleReject = () => {
    onClick(reason, customService, bannerService);
    setReason("");
    setCustomService(false);
    setBannerService(false);
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title className="w-100 d-flex justify-content-between">
          <span className="font-weight-bold h5">{title}</span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {subtitle && <p style={{ fontWeight: "600" }}>{subtitle}</p>}
        <Form>
          <Form.Group>
            <Form.Control
              type="text"
              placeholder={hint}
              style={{ margin: 0 }}
              value={reason}
              onChange={(e) => setReason(e.target.value)}
            />
          </Form.Group>
          <Form.Group className="pt-2">
            <Form.Check
              type="switch"
              id="custom-switch"
              label="Custom Service"
              checked={customService}
              onChange={(e) => setCustomService(e.target.checked)}
            />
          </Form.Group>
          <Form.Group className="pt-2">
            <Form.Check
              type="switch"
              id="banner-switch"
              label="Banner Service"
              checked={bannerService}
              onChange={(e) => setBannerService(e.target.checked)}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <span
          style={{
            fontWeight: "bold",
            cursor: "pointer",
            color: "#9095A0",
            marginRight: "1.2rem",
          }}
          onClick={onCancel}
        >
          Cancel
        </span>
        <Button
          variant="primary"
          onClick={handleReject}
          disabled={!reason}
          style={
            isDanger
              ? { backgroundColor: "var(--tertiary-color)", color: "white" }
              : {}
          }
        >
          {buttonText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CategoryAlertDialog;
